module.exports = __webpack_public_path__ + "media/images/paisaje_2-75a2b9cc.jpg";